// extracted by mini-css-extract-plugin
export default {"searchBox":"ProductSearch_searchBox__AEOeG"};